import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.response.use(
  res => res,
  err => {
    console.error('API Error:', err.response?.data || err.message)
    return Promise.reject(err)
  }
)

export const conversationApi = {
  list: (userId) =>
    api.get('/conversations', { params: { userId } }).then(r => r.data),

  create: (userId, navixySessionKey, title = 'Nova poruka') =>
    api.post('/conversations', { userId, navixySessionKey, title }).then(r => r.data),

  delete: (id) =>
    api.delete(`/conversations/${id}`).then(r => r.data),

  rename: (id, title) =>
    api.patch(`/conversations/${id}/rename`, { title }).then(r => r.data),
}

export const messageApi = {
  list: (conversationId) =>
    api.get(`/conversations/${conversationId}/messages`).then(r => r.data),

  send: (conversationId, content, userId) =>
    api.post(`/conversations/${conversationId}/messages`, { content, userId }).then(r => r.data),
}

export default api
